import React, { useState } from "react";
import { get, post } from "services/httpClient/HttpClient";

//if you have isParams true your data (object) will send as parameters
const useFetch = (url, method, isParam, isAttach) => {
    const [response, setResponse] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState(null)

    //main function for fetch requests. also handling loaders and errors
    //callBack param is your callback function
    const doFetch = async (body, callBack) => {
        setIsLoading(false)
        setError(null)

        //Params handling
        const handleUrl = isParam ? `${url}?${new URLSearchParams(body).toString()}` : url

        //GET method
        if(method == "get") {
            await get(handleUrl, setError).then(
                (res) => {setResponse(res); if(callBack) callBack(res)}
            ).finally(
                () => setIsLoading(true)
            ).catch(
                (err) => {setError(err)}
            )
        }
        //POST method
        if(method == "post") {
            await post(handleUrl, (isParam ? undefined : body), isAttach, setError).then(
                (res) => {setResponse(res); if(callBack) callBack(res)}
            ).finally(
                () => setIsLoading(true)
            )
        }
    }

    return [{ response, isLoading, error }, doFetch]
}

export default useFetch